import { InputProps } from '@app/types'
import { Input as AntInput, InputRef } from 'antd'
import { forwardRef } from 'react'

export const Input = forwardRef<InputRef, InputProps>((props, ref) => (
  <AntInput {...props} ref={ref as any} /> // Type assertion to bypass TypeScript error
))
